module.exports = __webpack_public_path__ + "img/云存储服务.182483cb.jpg";